import { atom } from "recoil";
import { IOperationsGroup } from "../types";

export const addStateOperationsGroup = atom({
  key: "addStateOperationsGroup",
  default: false,
});
export const editStateOperationsGroup = atom({
  key: "editStateOperationsGroup",
  default: false,
});
export const rowEditOperationsGroup = atom<IOperationsGroup | undefined>({
  key: "rowEditOperationsGroup",
  default: undefined,
});

export const selectedRowsStateOperationsGroup = atom<IOperationsGroup[]>({
  key: "selectedRowsStateOperationsGroup",
  default: [],
});

export const operationsGroupFilterText = atom({
  key: "operationsGroupFilterText",
  default: "",
});

export const operationsGroupFetching = atom({
  key: "operationsGroupFetching",
  default: true,
});
export const operationsGroupReFetching = atom({
  key: "operationsGroupReFetching",
  default: false,
});
